import React from 'react';
import ParentCreation from '../components/loggedout/parent-creation';
import { TurnstileProvider } from '../components/turnstile/context/TurnstileContext';
import { Turnstile } from '../components/turnstile/constants';
const ParentSignup = () => {
  return(
    <TurnstileProvider actionSource={Turnstile.ACTIONS.PARENT_SIGNUP_FORM}>
      <ParentCreation/>
    </TurnstileProvider>
  )
}

export default ParentSignup;